
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grouphubs/GroupHubPage/GroupHubPage",
      function () {
        return require("private-next-pages/grouphubs/GroupHubPage/GroupHubPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grouphubs/GroupHubPage/GroupHubPage"])
      });
    }
  